import { memo, useState } from "react";
import { RoomTypeSelect } from "../../common/RoomTypeSelect";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

export type AddRoomTypeProps = {
    defaultValue?:string;
    selectedHotel?:string;
    onSelected?:Function;
    fnAddNew?: Function;
    fnModalClose?: Function;
}

export const AddRoomType = memo(function AddRoomType(props: AddRoomTypeProps) {
    const { t } = useTranslation();
    const [selectedData, setSelectedData] = useState<string | string[]>();

    const addNew = () => {
        props.fnAddNew && props.fnAddNew(selectedData);
    }
    const closeModal = () => {
        props.fnModalClose && props.fnModalClose();
    }
    const onSelected = (value:string | string[]) => {
        setSelectedData(value);
        props.onSelected && props.onSelected();
    }
    return (
        <>
        <div className="row">
            <div className="col-sm-3 mt-4 pt-1 text-end">
                <label className=" text-right">{t("common.choose")} : </label>
            </div>
            <div className="col-sm-9 mt-4">
                <div className="me-2">
                    <RoomTypeSelect onChange={onSelected} defaultValue={props.defaultValue} selectedHotel={props.selectedHotel}/>
                </div>
            </div>
            <div className="col-md-12 mt-4 text-end ">
                <Button className="btn btn-secondary btn-dim me-2 " onClick={addNew} disabled={!selectedData}>{t("common.addNew")}</Button>
                <Button className="btn btn-danger btn-dim me-2 " onClick={closeModal}>{t("common.close")}</Button>
            </div>
        </div>
        </>
    )
})